module.exports = __webpack_public_path__ + "static/media/importSchoolCooperationPerson.1e1fb49a.xlsx";